import { useNavigate } from "react-router-dom";
import { CUSTOMER_SUCCESS_EMAIL, CUSTOMER_SUCCESS_MAILTO, PATH_DASHBOARD } from "config";
import { CheckoutStatusPanel } from "../CheckoutStatusPanel";

export const OtpPurchaseErrorResult: React.FC = () => {
  const navigate = useNavigate();

  return (
    <CheckoutStatusPanel
      variant="error"
      title="We couldn’t confirm your purchase"
      description="Something went wrong while verifying your payment. Check Billing for your license, try purchasing again, or contact support if you were charged."
      primaryAction={{
        label: "Go to Billing",
        onClick: () => navigate(PATH_DASHBOARD.billing),
      }}
      secondaryAction={{
        label: "Go to Home",
        onClick: () => navigate(PATH_DASHBOARD.home),
      }}
      footer={
        <p className="text-sm text-muted-foreground">
          Need help?{" "}
          <a
            href={CUSTOMER_SUCCESS_MAILTO}
            className="underline underline-offset-2 hover:text-foreground transition-colors"
          >
            {CUSTOMER_SUCCESS_EMAIL}
          </a>
        </p>
      }
    />
  );
};
